import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-tiktok-icon',
  templateUrl: 'tiktok-icon.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TiktokIconComponent {
}

